import * as React from 'react'

import { cn } from '@/lib/utils'

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'> & {
    isInvalid?: boolean
  }
>(({ className, isInvalid, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        'flex min-h-[80px] w-full rounded-2xl border !border-monochrome-120 !bg-monochrome-3-60 text-monochrome-1 px-3 py-2 !text-button-m placeholder:text-monochrome-120 focus-visible:outline-none focus-visible:!border-accent-1 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        isInvalid && '!border-accent-3 focus-visible:border-accent-3',
        className,
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = 'Textarea'

export { Textarea }
